import Fab from '@material-ui/core/Fab'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import { withStyles } from '@material-ui/styles'
import React, { Component } from 'react'
import { getEMPI, getMyneedsEOS, getMyneedsEOSnew } from '../ApiCall'
import CommonLoader from '../CommonLoader'
import CommonFooter from './CommonFooter'
import DataTable from './DataTable';
import DataTableNew from './DataTableNew'
import Header from './Header'
import './MyNeeds.css'
import { Button, Tab, Tabs } from '@material-ui/core'
import customStyle from './programInfo/CSS/stylesheet_UHS.js'
import ContributionDataTable from './ContributionDataTable'
import Reimbursements from './Reimbursement/Reimbursements'
import axios from 'axios';
import { jsPDF } from "jspdf";
import ReimbursementUpload from './Reimbursement/ReimbursementUpload'

const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

const CrudButton = withStyles(customStyle.crudBtn)(Fab)
export default class MyNeeds extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableData: [],
      loader: true,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '', 
      open: false,
      tabEnable: localStorage.getItem("isAdmin") || localStorage.getItem("NETWORK_NAME") == "senior65" ? true: false,
      selectedTab:"MyShareRequests",
      isReimbursementFlow: false,
      files: [],
    }
  }

  componentDidMount() {
    this.getEMPID()
    let urlValues  = new URLSearchParams(window.location.search);
    let a =urlValues.get('open');
    if(a==true || a=="true")
    this.setState({open: true}, ()=>{
      this.props.history.push('/MyNeeds')
    })
  }

  getEMPID() {
    getEMPI().then(res => {
      this.myneedsEOS()
    })
    // this.setState({tableData: arrayNeeds, loader: false})
  }

  myneedsEOS = () => {
    getMyneedsEOS().then(res => {
      if (res.data && res.data.length > 0) {
        this.setState({ tableData: res.data, loader: false })
      } else {
        this.setState({
          notfoundmsg1: 'No needs have been entered into the system.',
          notfoundmsg2: 'Submitted needs may take 2-3 days to be displayed here.',
          notfoundmsg3: 'For any clarifications call Customer Service.',
          loader: false
        })
      }
    }).catch(err=>{
      this.setState({ loader: false })
    })
  }

  goBack = () => {
    this.props.history.push('/')
  }

  reimbursementFlowChange = () => {
    this.setState({ isReimbursementFlow: !this.state.isReimbursementFlow })
  }

  render() {
    if(this.state.isReimbursementFlow) return <ReimbursementUpload backClick={()=>this.setState({isReimbursementFlow:false, memberid:null, referenceId:null, selectedTab:"reimbursements"})}/>

    return (
      <div className="progInfoMainWrapper">
        <Header name={'MyNeeds'} />
        {this.state.loader ? <CommonLoader /> : null}
        <div className="container progInfoContainer" style={{ zIndex: '0' }}>
          <sapn className="Back_page" onClick={this.goBack}>
            <ArrowBackIcon style={{ width: '24px', height: '24px', color: ' #2e3192', marginRight: '5px' }} onClick={this.goBack} />
            BACK
          </sapn>

          <div className="commonWrap_MyNeeds" style={{ marginTop: '15px' }}>
           {!this.state.tabEnable && <div className="progInfoSection" style={{ marginBottom: '-20px' }}>
              <h2 className="progInfoTitle">MY NEEDS</h2>
            </div>}
           {this.state.tabEnable && <AntTabs
                value={this.state.selectedTab}
                onChange={(e, newValue) => this.setState({selectedTab: newValue})}
                textColor="#33333"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
                variant="fullWidth"
                scrollButtons="false"
                id="tabs"
                style={{ width: '100%' }}
                slotProps={{scrollButtons: false}}
              >
                <Tab label="MY NEEDS" value="MyShareRequests" style={{ textTransform: 'capitalize',width:'13%',marginTop:10,fontSize:24, color: this.state.selectedTab == 'MyShareRequests' ? '#000' : '#7e7e7e'}} />
                {
                  localStorage.getItem("isAdmin") &&
                  <Tab label="MY CONTRIBUTIONS" value="MyCONTRIBUTIONS" style={{ textTransform: 'capitalize',width:'20%',marginTop:10,fontSize:24, color: this.state.selectedTab == 'MyCONTRIBUTIONS' ? '#000' : '#7e7e7e' }} />
                }
                {
                  localStorage.getItem("NETWORK_NAME") == "senior65" &&
                  <Tab label="MY REIMBURSEMENTS" value="reimbursements" style={{ textTransform: 'capitalize',width:'20%',marginTop:10,fontSize:24, color: this.state.selectedTab == 'reimbursements' ? '#000' : '#7e7e7e' }} />
                }
              </AntTabs>}
            <div>
              {this.state.selectedTab === "MyShareRequests" && 
              <div className="tablebackgroundouter">
                {this.state.tableData && this.state.tableData.length > 0 ? (
                    this.state.tabEnable?
                    <DataTableNew  open={this.state.open} tableData={this.state.tableData} />
                    :
                  <DataTable open={this.state.open} tableData={this.state.tableData} />
                ) : (
                  <>
                    <div className="data_not_found">
                      <h5 class="noneeds_msg_display">{this.state.notfoundmsg1}</h5>
                      <h5 class="noneeds_msg_display">{this.state.notfoundmsg2}</h5>
                      <h5 class="noneeds_msg_display">{this.state.notfoundmsg3}</h5>
                    </div>
                  </>
                )}
              </div>}

              {this.state.tabEnable && this.state.selectedTab === "MyCONTRIBUTIONS" && 
              <div className="tablebackgroundouter">
                <ContributionDataTable/>
              </div>}

              {this.state.tabEnable && this.state.selectedTab === "reimbursements" && 
              <div key={this.state.isReimbursementFlow} className="tablebackgroundouter">
                <Reimbursements />
              </div>}

              <div className="progInfoFooter">
                <div className="row">
                  <div className="col-md-8">
                    {this.state.tabEnable && this.state.selectedTab === "reimbursements" ?
                        <Button variant='filled' style={{ height: 40, width: 300, backgroundColor: '#60bec9', color: "#fff", borderRadius: 25 }} onClick={() => this.reimbursementFlowChange()}>
                          Reimbursement Request
                        </Button>
                      : null
                    }
                  </div>
                  <div className="col-md-4 dpFlex">
                    <div className="footerText" style={{ display: 'flex', flexDirection: 'row',whiteSpace:'nowrap' }}>
                      <div>
                        <p>Need help?</p>
                        <p>Chat with a Universal Health Fellowship Representative</p>
                        <p>{`or call ${localStorage.getItem('CONTACT_NUMBER')}`}
                      {/* {(() => {
                        var client_id_locale = localStorage.getItem('CLIENT_ID')
                        if (client_id_locale == '3211' || client_id_locale == '3098') {
                          return '(888) 366 6243'
                        } else {
                          return '(877)-987-1233'
                        }
                      })()} */}
                    </p>
                      </div>
                      <div style={{ marginLeft: 12 }}>
                        <CrudButton
                          className={'purechat-button-expand'}
                          color="primary"
                          onClick={() => window.pureChat()}
                          aria-label="add"
                          style={customStyle.CommonChatBtn}
                        >
                          <ForumIcon />
                        </CrudButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ paddingTop: "23vh" }}>
          <CommonFooter />
        </div>
      </div>
    )
  }

  openChat = () => {
    sessionStorage.setItem('chatwindow', true)
    this.props.history.push('/')
  }
}
const arrayNeeds =[
  {"member_id": "CNEO10421340", 
  "empi": "1015", 
  "bill_key": "20766", 
  "first_name": "Elaine", 
  "last_name": "Williams", 
  "date_paid": "2020-12-03", 
  "date_received": "2020-07-02", 
  "status": "Paid", 
  "charged_amount": 527.00, 
  "paid_amount": 451.37, 
  "paid_provider_name": "HealthWay Clinic.", 
  "start_of_service_date": "2020-03-10", 
  "end_date_of_service": "2020-03-10", 
  "nsa": 0.00, 
  "sharing_percentage": 0.0, 
  "consultation_fee": 25.0, 
  "ineligible_amount": 15.70, 
  "repricing_amount": 34.93, 
  "eligible_for_sharing": 451.37, 
  "member_responsibility": 40.70
},


]